module.exports = __webpack_public_path__ + "static/media/education_video_icon.67e0dc43.svg";